import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import * as _ from 'lodash';
import * as moment from 'moment';
import { forkJoin, Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Customer } from './../../../../../_shared/model/customer.model';
import { ReservationHistory } from './../../../../../_shared/model/history.model';
import { HelperService } from './../../../../../_shared/services';
import { HelperNavigateService } from './../../../../../_shared/services/helper-navigate.service';
import { BaseState } from './../../../../../_shared/state/base/base.state';
import { CustomerService } from './../../_services/customer.service';

@Component({
    selector: 'main-cal-customer-search',
    templateUrl: './main-cal-customer-search.component.html',
    styleUrls: ['./main-cal-customer-search.component.scss'],
})
export class MainCalCustomerSearchComponent implements OnInit {
    @Input()
    set setCustomer(data: Customer) {
        if (data) {
            this.customer = data;
            this.fetchCustomerData();
        }
    }

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onClose: EventEmitter<string> = new EventEmitter();
    public customer: Customer;
    public reservatonsHistory: ReservationHistory[] = [];
    private contractorId = this.store.selectSnapshot(BaseState.activeContractorId);

    private onDestroy$ = new Subject<void>();
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }
    constructor(
        private customerRest: CustomerService,
        private store: Store,
        public helper: HelperService,
        private helperNav: HelperNavigateService,
    ) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onSelect({ selected }: any): void {
        if (selected?.length > 0) {
            this.helperNav.navigateToReservaton(selected[0]?.data?.prereservationId);
        }
    }
    public fetchCustomerData() {
        const a: Observable<ReservationHistory[]> = this.customerRest.getCustomerHistory(this.contractorId, this.customer.id).pipe(
            takeUntil(this.onDestroy$),

            map(data => {
                return data.map(el => {
                    if (!el.reservationTime) {
                        el.reservationTime = el.visitDate;
                    }
                    return {
                        type: 'visit',
                        data: el,
                        date: moment(el.reservationTime).toDate(),
                        subcontractorName: el.subcontractorName,
                        comment: el.comment,
                        status: 0,
                    };
                });
            }),
        );

        const b: Observable<ReservationHistory[]> = this.customerRest.getCustomerReservations(this.contractorId, this.customer.id, null, null).pipe(
            takeUntil(this.onDestroy$),
            map(data => {
                return data
                    .filter(el => _.isNil(el.visitId))
                    .map(el => {
                        return {
                            type: 'reservations',
                            data: el,
                            date: moment(el.reservationFrom).toDate(),
                            subcontractorName: _.get(el, 'contractor.subcontractors[0].name', ''),
                            comment: el.comment,
                            status: el.status,
                            noShow: el.noShow,
                        };
                    });
            }),
        );

        forkJoin([a, b])
            .pipe(
                takeUntil(this.onDestroy$),

                map(data => {
                    return _.flatten(data).sort((a: ReservationHistory, b: ReservationHistory) => {
                        let result = 1;
                        if (a.date > b.date) {
                            result = -1;
                        }
                        return result;
                    });
                }),
            )
            .subscribe(data => {
                this.reservatonsHistory = data;
            });
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onActivate(event: any) {
        if (event.type === 'click') {
            event.cellElement.blur();
        }
    }
}
